import { render } from "./tender_files_add.vue?vue&type=template&id=03848e6e"
import script from "./tender_files_add.vue?vue&type=script&lang=js"
export * from "./tender_files_add.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tender/request/tender_files_add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03848e6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03848e6e', __exports__)) {
    console.log('reload')
    api.reload('03848e6e', __exports__)
  }
  
  module.hot.accept("./tender_files_add.vue?vue&type=template&id=03848e6e", () => {
    console.log('re-render')
    api.rerender('03848e6e', render)
  })

}


export default __exports__